import { ElementStyles } from '@microsoft/fast-element';
import { PropertyStyleSheetBehavior } from '../foundation/property-stylesheet-behavior';

/**
 * Behavior that will conditionally apply a stylesheet based on the elements appearance property
 *
 * @param value - The value of the appearance property
 * @param styles - The styles to be applied when condition matches
 *
 * @public
 */
 export function appearanceBehavior(value: string, styles: ElementStyles) {
    return new PropertyStyleSheetBehavior('appearance', value, styles);
}

/**
 * Behavior that will conditionally apply a stylesheet based on the elements variant property
 *
 * @param value - The value of the variant property
 * @param styles - The styles to be applied when condition matches
 *
 * @public
 */
 export function variantBehavior(value: string, styles: ElementStyles) {
    return new PropertyStyleSheetBehavior('variant', value, styles);
}

/**
 * Behavior that will conditionally apply a stylesheet based on the elements color property
 *
 * @param value - The value of the color property
 * @param styles - The styles to be applied when condition matches
 *
 * @public
 */
 export function colorBehavior(value: string, styles: ElementStyles) {
    return new PropertyStyleSheetBehavior('color', value, styles);
}

/**
 * Behavior that will conditionally apply a stylesheet based on the value of the specified property
 *
 * @param attribute - The attribute to check
 * @param value - The value of the variant property
 * @param styles - The styles to be applied when condition matches
 *
 * @public
 */
export function attributeBehavior(attribute: string, value: string, styles: ElementStyles) {
    return new PropertyStyleSheetBehavior(attribute, value, styles);
}
